// Static Assets
import image_logo_ifsokak from '/assets/images/partners/ifsokak.png';
import image_logo_biletix from '/assets/images/partners/biletix.svg';
import image_logo_pancar from '/assets/images/partners/pancar.png';
import image_logo_vamos from '/assets/images/partners/vamos.png';
import image_logo_tint from '/assets/images/partners/tint.png';
import image_logo_bigfood from '/assets/images/partners/bigfood.png';
import image_logo_virgin from '/assets/images/partners/virgin.png';
import image_logo_joyturk from '/assets/images/partners/joyturk.png';

const partners = [
	{
		title: 'IF Sokak',
		image: image_logo_ifsokak,
		link: 'https://ifsokak.com/',
	},
	{
		title: 'Biletix',
		image: image_logo_biletix,
		link: 'https://www.biletix.com/anasayfa/TURKIYE/tr',
	},
	{
		title: 'Pancar',
		image: image_logo_pancar,
		link: 'https://www.pancar.com.tr/',
	},
	{
		title: 'Vamos',
		image: image_logo_vamos,
		link: 'https://vamooos.com/',
	},
	{
		title: 'Tint Cafe',
		image: image_logo_tint,
		link: 'https://tintcafe.com/',
	},
	{
		title: 'Big Food',
		image: image_logo_bigfood,
		link: 'https://bigfood.com.tr/',
	},
	{
		title: 'Virgin Radio',
		image: image_logo_virgin,
		link: 'https://karnaval.com/radyolar/virginradio',
	},
	{
		title: 'Joyturk',
		image: image_logo_joyturk,
		link: 'https://karnaval.com/radyolar/joyturk',
	},
]

export default partners;